import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MetadatiService } from 'src/app/amministrazione/components/metadati/metadati/service/metadati.service';
import { Metadata, MetadataExt } from 'src/app/common/models/metadati/metadata';
import { PraticaLight } from 'src/app/common/models/pratica/pratica-light';

@Component({
  selector: 'app-pratica-metadata-form',
  templateUrl: './pratica-metadata-form.component.html',
  styleUrls: ['./pratica-metadata-form.component.css']
})
export class PraticaMetadataFormComponent implements OnInit,OnChanges {

  @Input() tipoPratica:string;
  @Input() pratica: PraticaLight;
  @Output() metadataListChange: EventEmitter<MetadataExt[]> = new EventEmitter();
  @Output() formChange: EventEmitter<boolean> = new EventEmitter();
  metadata:MetadataExt[] = [];

  constructor(
    private metadatiService: MetadatiService) {

  }
  ngOnChanges(changes: SimpleChanges): void {

    if(changes.tipoPratica){
      this.metadatiService.findAllByPracticeType(this.tipoPratica).subscribe(next => {
        if(next.length == 0){
          this.formChange.emit(true);
        }
        this.metadata = next.sort((a, b) => a.order - b.order).map(obj => obj.item as MetadataExt);
      });
    }

    if(changes.pratica){
      this.metadatiService.findAllByPracticeType(this.pratica.tipoPratica.id).subscribe(next => {
        this.metadata = [];
        let metadataPratica = []
        if(this.pratica.metadata && this.pratica.metadata.length != 0){
          metadataPratica = this.pratica.metadata.sort((a, b) => a.order - b.order).map(obj => obj);
          this.metadata.push(...metadataPratica);
        }
        let metadataAssociated = []
        let nuoviElementi = []
        if(next && next.length != 0){
          metadataAssociated = next.sort((a, b) => a.order - b.order).map(obj => obj.item as MetadataExt);
          nuoviElementi = metadataAssociated.filter(item => !metadataPratica.some(itemAssociated => itemAssociated.id === item.id)).sort((a, b) => a.order - b.order);
          if(nuoviElementi.length != 0){
          this.metadata.push(...nuoviElementi);
          }
        }
        if(this.metadata.length == 0){
          this.formChange.emit(true);
        }
      });

    }
  }

  ngOnInit(): void {
  }

  retrieveMetadataExt(metadata:MetadataExt[]){
    this.metadataListChange.emit(metadata.filter(s => s.value != null && s.value != ""));
  }

  retrieveFormValid(value : FormGroup){
    this.formChange.emit(value.valid);
  }




}
